import type { DynamicClient } from '../../../../client/types';
import { NoWalletProviderFoundError } from '../../../../errors/NoWalletProviderFoundError';
import type { WalletAccount } from '../../walletAccount';
import { getWalletProviderRegistry } from '../../walletProviderRegistry';

type GetWalletProviderFromWalletAccountParams = {
  walletAccount: WalletAccount;
};

export const getWalletProviderFromWalletAccount = (
  { walletAccount }: GetWalletProviderFromWalletAccountParams,
  client: DynamicClient
) => {
  const walletProviderRegistry = getWalletProviderRegistry(client);

  const walletProvider = walletProviderRegistry.getByKey(
    walletAccount.walletProviderKey
  );

  if (!walletProvider) {
    throw new NoWalletProviderFoundError({
      walletProviderKey: walletAccount.walletProviderKey,
    });
  }

  return walletProvider;
};
